import * as React from 'react';
import { Reveal } from '@progress/kendo-react-animation';
import { useLocalization } from '@progress/kendo-react-intl';
import { messages, columnMenuFilterClearButton as clear, columnMenuFilterSubmitButton as submit } from '../messages';
/**
 * @hidden
 */
export function ColumnMenuFilterForm(props) {
    var localization = useLocalization();
    return (React.createElement("div", { className: "k-columnmenu-item-content" },
        React.createElement(Reveal, { style: { position: 'relative', display: 'block' } }, props.show && (React.createElement("div", { className: "kendo-grid-filter-menu-container" },
            React.createElement("form", { className: "k-filter-menu k-group k-reset k-state-border-up", onSubmit: props.onSubmit, onReset: props.onReset },
                React.createElement("div", { className: "k-filter-menu-container" },
                    props.children,
                    React.createElement("div", { className: "k-columnmenu-actions" },
                        React.createElement("button", { className: "k-button", type: "reset" }, localization.toLanguageString(clear, messages[clear])),
                        React.createElement("button", { className: "k-button k-primary" }, localization.toLanguageString(submit, messages[submit]))))))))));
}
//# sourceMappingURL=ColumnMenuFilterForm.js.map